import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom'; // Ensure Navigate is imported

// Helper function to check for authentication
const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('authToken') && !!localStorage.getItem('userData');
};

// Define the props type for PrivateRoute
interface PrivateRouteProps {
  children: ReactNode; // Specify the type for children
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  return isAuthenticated() ? <>{children}</> : <Navigate to="/signin" />;
};

export default PrivateRoute;
